<template>
  <a-modal :destroyOnClose="true"
  :mask-closable="false"
  style="top: 80px;"
  width="700px"
  v-model="visible"
  :title="$t('添加用户')">
      <div slot="footer">
          <a-button :loading="loading" @click="handleCancel" style="background-color: #ffffff; color: #000; font-size: 14px; height: 32px; border: 1px solid #DEE0E3;">{{ $t('取消') }}</a-button>
          <a-button :loading="loading" @click="handleSave" style="background-color: #2F88F8; color: #ffffff; font-size: 14px; height: 32px; border: none;">{{ $t('确定') }}</a-button>
      </div>
      <a-table style="margin-top: 10px;" ref="userTable" :columns="userColumns" :dataSource="tableData" rowKey="id" :rowSelection="{selectedRowKeys: selectedUserRowKeys, onChange: onSelectUserChange}" />                
  </a-modal>    
</template>
<script>
import { getUserList } from '@/api/user/user'
import { addMembers } from '@/api/system/dept'
import { getLabelFromOptions } from '@/utils/dictUtils'
import { UserStatusOptions } from '../config/UserConfig'

export default {
  data () {
      return {
          visible: false,
          depart: null,
          tableData: [],
          selectedUserRowKeys: [],
          selectedUserRows: [],
          loading: false,
      }
  },
  computed: {
    userColumns() {
        return [
              {
                  title: this.$t('用户名称'),
                  dataIndex: 'userName',
              },
              {
                  title: this.$t('账号状态'),
                  dataIndex: 'status',
                  customRender: (text) => {
                      return getLabelFromOptions(text, UserStatusOptions, text)
                  }
              },
              {
                  title: this.$t('账户名'),
                  dataIndex: 'loginName',
              },
          ]
    }
  },
  methods: {
      show (record) {
          this.depart = Object.assign({}, record)
          this.prepareData()
          this.visible = true
      },
      prepareData () {
          this.loading = false
          this.selectedUserRowKeys = []
          this.selectedUserRows = []
          this.tableData = []
          this.loadUserData()
      },
      loadUserData () {
        getUserList({ appId: this.depart.appId }).then(res => {
          this.tableData = res.data || []
        })
      },
      onSelectUserChange (selectedRowKeys, selectedRows) {
          this.selectedUserRowKeys = selectedRowKeys
          this.selectedUserRows = selectedRows
      },
      handleCancel () {
          this.visible = false
      },
      handleSave () {
          if (this.selectedUserRows.length == 0) {
              this.$message.error(this.$t('请选择要添加的用户'))
              return
          }
          const commitData = this.selectedUserRows.map(item => ({
            deptId: this.depart.id,
            userId: item.id
          }))
          this.loading = true
          addMembers(commitData).then(res => {
            if (res.code === 0) {
                this.$message.success(this.$t('添加用户成功'))
                this.$emit('ok')
                this.visible = false
            } else {
                this.$message.error(res.message || this.$t('添加用户失败'))
            }
          }).catch (err => {
            this.$message.error(this.$t('添加用户失败'))
          }).finally (() => {
            this.loading = false
          })
      },
  }

}
</script>

